import React, { useState } from 'react'
import DatePicker from "react-datepicker";
import { Link, useNavigate } from 'react-router-dom'
import { country_code_array2 } from './functions';
import { domestic_destination_array } from './functions';
import "react-datepicker/dist/react-datepicker.css";
import '../../Home1.css'
import banner from '../../images/home/time-home-bg-1.jpg'
import Parcels_delivered from './home_components/Parcels_delivered';
import { Helmet } from 'react-helmet';
import BACKEND_URL from '../../api';
import { useCountry } from '../../context/CountryContext';

export default function Home1() {

    const navigate = useNavigate()
    const { citiesToCollect, weightUnit, dimensionUnit, selectedCountry } = useCountry()

    const url = window.location.href
    const ordertype = url.split("/").pop(); //for checking the link is for domestic

    sessionStorage.setItem('display_currency', 'SAR');

    const [countries, setcountries] = useState(country_code_array2);
    const [domesticloc, setdomesticloc] = useState(domestic_destination_array);

    const ip_code = '5.195.227.207'; // find ip
    sessionStorage.setItem('ip_code', ip_code)

    const [showdiv, setshowdiv] = useState('exportdiv')
    const [typediv, settypediv] = useState('package')
    const [exportclass, setexportclass] = useState('active')
    const [importclass, setimportclass] = useState('')
    const [exportListClass, setExportListClass] = useState(['active'])
    const [importListClass, setImportListClass] = useState([''])
    const [exportHeavyListClass, setExportHeavyListClass] = useState(['active'])
    const [importHeavyListClass, setImportHeavyListClass] = useState([''])
    const [packListClass, setPackListClass] = useState(['active'])
    const [packHeavyListClass, setPackHeavyListClass] = useState(['active'])
    const [docListClass, setDocListClass] = useState([''])
    const [docHeavyListClass, setDocHeavyListClass] = useState([''])
    const [packclass, setpackclass] = useState('active')
    const [docclass, setdocclass] = useState('')
    const [qoutefor, setqoutefor] = useState('international')
    const [title, settitle] = useState('The Cheapest Parcel Delivery In The UAE.')
    function changefun(get_id) {
        if (get_id == 'in-package-document-tab') {
            settitle("The Cheapest Parcel Delivery In The UAE.")
            setqoutefor('international');
        } else if (get_id == 'in-freight-tab') {
            settitle("Priority Service For Heavier Shipments.")
        } else if (get_id == 'road-gcc-tab') {
            settitle("Economy Truck Service Express For Heavy Boxes (GCC Only).");
        } else if (get_id == 'multiple-shipments-tab') {
            settitle("The Cheapest Multiple Parcel Delivery In The UAE.")
        } else if (get_id == 'heavy-shipments-tab') {
            settitle("The Cheapest Heavy Parcel Delivery In The UAE.");
        } else {
            settitle("Send A Parcel Anywhere In The UAE.");
            setqoutefor('domestic');
        }
    }

    const date = new Date();
    const today = date.getDay()
    const [startDate, setStartDate] = useState(today == 6 ? new Date(date.setDate(date.getDate() + 2)) : new Date(date.setDate(date.getDate() + 1)))

    const date2 = new Date();
    const today2 = date2.getDay()
    const [startDate2, setStartDate2] = useState(today2 == 6 ? new Date(date2.setDate(date2.getDate() + 2)) : new Date(date2.setDate(date2.getDate() + 1)))

    const isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0;
    };

    const [fordomestic, setfordomestic] = useState(ordertype == 'domestic' ? 'domestic' : 'international')
    const [makeactive, setmakeactive] = useState(ordertype == 'domestic' ? '' : 'show active')
    const [makeactivedom, setmakeactivedom] = useState(ordertype == 'domestic' ? 'show active' : '')
    const user = sessionStorage.getItem('userid');

    const [getQuotedata, setgetQuotedata] = useState(
        {
            user: user,
            origin: 'AE',
            destination: 'GB',
            shipmenttype: "exportdiv",
            typediv: "package",
            shipping_date: startDate,
            dimensions: {
                weight: ['0.5'],
                length: ['0'],
                width: ['0'],
                height: ['0']
            }
        }
    )

    const [getQuotedata_dom, setgetQuotedata_dom] = useState(
        {
            user: user,
            origin: 'DXB',
            destination: 'AUH',
            shipmenttype: "domestic",
            typediv: "package",
            shipping_date: startDate,
            dimensions: {
                weight: ['0.5'],
                length: ['0'],
                width: ['0'],
                height: ['0']
            }
        }
    )

    const [getQuotedatalist, setgetQuotedatalist] = useState([
        {
            user: user,
            origin: 'AE',
            destination: 'GB',
            shipmenttype: "exportdiv",
            typediv: "package",
            shipping_date: startDate,
            dimensions: {
                weight: ['0.5'],
                length: ['0'],
                width: ['0'],
                height: ['0']
            }
        }
    ])

    const [getQuoteHeavydatalist, setgetQuoteHeavydatalist] = useState([
        {
            user: user,
            origin: 'AE',
            destination: 'GB',
            shipmenttype: "exportdiv",
            typediv: "pallet",
            shipping_date: startDate,
            dimensions: {
                weight: ['71'],
                length: ['0'],
                width: ['0'],
                height: ['0']
            }
        }
    ])

    const [weightmsg, setweightmsg] = useState()

    function updateweight(val, i) {
        if (val == '70+') {
            setweightmsg(1)
        } else {
            setweightmsg(0)
            const updatedCount = 1;
            const clonedListing = { ...getQuotedata.dimensions };
            const updatedAccepted = [...clonedListing.weight]

            updatedAccepted[i] = val;
            setgetQuotedata({
                ...getQuotedata,
                dimensions: {
                    ...clonedListing,
                    weight: updatedAccepted
                }
            });
        }
    }

    function updatelength(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.length]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                length: updatedAccepted
            }
        });
    }

    function updatewidth(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.width]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                width: updatedAccepted
            }
        });
    }

    function updateheight(val, i,) {
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.height]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                height: updatedAccepted
            }
        });
    }

    function updateweightlist(val, i) {
        if (val == '70+') {
            setweightmsg(1)
        } else {
            setweightmsg(0)
            const updatedData = [...getQuotedatalist]; // Create a shallow copy of the array
            updatedData[i] = {
                ...updatedData[i], // Copy existing properties of the object at index i
                dimensions: {
                    ...updatedData[i].dimensions, // Copy existing dimensions
                    weight: [
                        val, // Update the first element with val
                        ...updatedData[i].dimensions.weight.slice(1) // Keep the rest of the existing lengths
                    ]
                }
            };
            setgetQuotedatalist(updatedData);
        }
    }

    function updateHeavyWeight(val, i) {
        if (val == '70+') {
            setweightmsg(1)
        } else {
            setweightmsg(0)
            const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
            updatedData[i] = {
                ...updatedData[i], // Copy existing properties of the object at index i
                dimensions: {
                    ...updatedData[i].dimensions, // Copy existing dimensions
                    weight: [
                        val, // Update the first element with val
                        ...updatedData[i].dimensions.weight.slice(1) // Keep the rest of the existing lengths
                    ]
                }
            };
            setgetQuoteHeavydatalist(updatedData);
        }
    }

    function updatelengthlist(val, i) {
        const updatedData = [...getQuotedatalist]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                length: [
                    val, // Update the first element with val
                    ...updatedData[i].dimensions.length.slice(1) // Keep the rest of the existing lengths
                ]
            }
        };
        setgetQuotedatalist(updatedData); // Update the state with the new array
    }

    function updateHeavyLength(val, i) {
        const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                length: [
                    val, // Update the first element with val
                    ...updatedData[i].dimensions.length.slice(1) // Keep the rest of the existing lengths
                ]
            }
        };
        setgetQuoteHeavydatalist(updatedData); // Update the state with the new array
    }

    function updatewidthlist(val, i) {
        const updatedData = [...getQuotedatalist]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                width: [
                    val, // Update the first element with val
                    ...updatedData[i].dimensions.width.slice(1) // Keep the rest of the existing lengths
                ]
            }
        };
        setgetQuotedatalist(updatedData);
    }

    function updateHeavyWidth(val, i) {
        const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                width: [
                    val, // Update the first element with val
                    ...updatedData[i].dimensions.width.slice(1) // Keep the rest of the existing lengths
                ]
            }
        };
        setgetQuoteHeavydatalist(updatedData);
    }

    function updateheightlist(val, i,) {
        const updatedData = [...getQuotedatalist]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                height: [val] // Update the weight property
            }
        };
        setgetQuotedatalist(updatedData);
    }

    function updateHeavyHeight(val, i,) {
        const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
        updatedData[i] = {
            ...updatedData[i], // Copy existing properties of the object at index i
            dimensions: {
                ...updatedData[i].dimensions, // Copy existing dimensions
                height: [val] // Update the weight property
            }
        };
        setgetQuoteHeavydatalist(updatedData);
    }

    function showthisdiv(val) {
        if (val == 'exportdiv') {
            setshowdiv('exportdiv')
            setexportclass('active')
            setimportclass('')
            setgetQuotedata({ ...getQuotedata, shipmenttype: val, origin: 'AE', destination: 'GB' })
        } else if (val == 'importdiv') {
            setshowdiv('importdiv')
            setexportclass('')
            setimportclass('active')
            setgetQuotedata({ ...getQuotedata, shipmenttype: val, origin: 'GB', destination: 'AE' })
        }
    }

    function showthisdivlist(val, i) {
        if (val == 'exportdiv') {
            const updateData = getQuotedatalist.map((item, index) => {
                if (index === i) {
                    return {
                        ...item,
                        shipmenttype: val,
                        origin: 'AE',
                        destination: 'GB'
                    };
                }
                return item;
            });
            setgetQuotedatalist(updateData);

            const updatedExportList = exportListClass.map((item, index) => {
                if (index == i) {
                    return 'active'
                } else {
                    return item;
                }
            });
            setExportListClass(updatedExportList);
            const updatedImportList = importListClass.map((item, index) => {
                if (index == i) {
                    return ''
                } else {
                    return item;
                }
            });
            setImportListClass(updatedImportList);
        } else if (val == 'importdiv') {
            const updateData = getQuotedatalist.map((item, index) => {
                if (index === i) {
                    return {
                        ...item,
                        shipmenttype: val,
                        origin: 'GB',
                        destination: 'AE'
                    };
                }
                return item;
            });
            setgetQuotedatalist(updateData);

            const updatedExportList = exportListClass.map((item, index) => {
                if (index == i) {
                    return ''
                } else {
                    return item;
                }
            });
            setExportListClass(updatedExportList);
            const updatedImportList = importListClass.map((item, index) => {
                if (index == i) {
                    return 'active'
                } else {
                    return item;
                }
            });
            setImportListClass(updatedImportList);
        }
    }

    function showheavydivlist(val, i) {
        if (val == 'exportdiv') {
            const updateData = getQuoteHeavydatalist.map((item, index) => {
                if (index === i) {
                    return {
                        ...item,
                        shipmenttype: val,
                        origin: 'AE',
                        destination: 'GB'
                    };
                }
                return item;
            });
            setgetQuoteHeavydatalist(updateData);

            const updatedExportList = exportHeavyListClass.map((item, index) => {
                if (index == i) {
                    return 'active'
                } else {
                    return item;
                }
            });
            setExportHeavyListClass(updatedExportList);

            const updatedImportList = importHeavyListClass.map((item, index) => {
                if (index == i) {
                    return ''
                } else {
                    return item;
                }
            });
            setImportHeavyListClass(updatedImportList);
        } else if (val == 'importdiv') {
            const updateData = getQuoteHeavydatalist.map((item, index) => {
                if (index === i) {
                    return {
                        ...item,
                        shipmenttype: val,
                        origin: 'GB',
                        destination: 'AE'
                    };
                }
                return item;
            });
            setgetQuoteHeavydatalist(updateData);

            const updatedExportList = exportHeavyListClass.map((item, index) => {
                if (index == i) {
                    return ''
                } else {
                    return item;
                }
            });
            console.log(val, updatedExportList)
            setExportHeavyListClass(updatedExportList);

            const updatedImportList = importHeavyListClass.map((item, index) => {
                if (index == i) {
                    return 'active'
                } else {
                    return item;
                }
            });
            setImportHeavyListClass(updatedImportList);
        }
    }

    function showtypediv(val) {
        if (val == 'package') {
            settypediv('package')
            setpackclass('active')
            setdocclass('')
        } else if (val == 'document') {
            settypediv('document')
            setpackclass('')
            setdocclass('active')
        }
        setgetQuotedata({ ...getQuotedata, typediv: val })
    }

    function showtypedivlist(val, i) {
        if (val == 'package') {
            const updateData = [...getQuotedatalist]; // Create a shallow copy of the array
            updateData[i].typediv = val;
            setgetQuotedatalist(updateData);

            const updatedPackageList = packListClass.map((item, index) =>
                index === i ? 'active' : item
            );
            setPackListClass(updatedPackageList);
            const updatedDocumentList = docListClass.map((item, index) =>
                index === i ? '' : item
            );
            setDocListClass(updatedDocumentList);
        } else if (val == 'document') {
            const updateData = [...getQuotedatalist];
            updateData[i].typediv = val;
            setgetQuotedatalist(updateData);

            const updatedPackageList = packListClass.map((item, index) =>
                index === i ? '' : item
            );
            setPackListClass(updatedPackageList);
            const updatedDocumentList = docListClass.map((item, index) =>
                index === i ? 'active' : item
            );
            setDocListClass(updatedDocumentList);
        }
    }

    function showheavytypedivlist(val, i) {
        if (val == 'pallet') {
            const updateData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
            updateData[i].typediv = val;
            setgetQuoteHeavydatalist(updateData);

            const updatedPackageList = packHeavyListClass.map((item, index) =>
                index === i ? 'active' : item
            );
            setPackHeavyListClass(updatedPackageList);
            const updatedDocumentList = docHeavyListClass.map((item, index) =>
                index === i ? '' : item
            );
            setDocHeavyListClass(updatedDocumentList);
        } else if (val == 'carton') {
            const updateData = [...getQuoteHeavydatalist];
            updateData[i].typediv = val;
            setgetQuoteHeavydatalist(updateData);

            const updatedPackageList = packHeavyListClass.map((item, index) =>
                index === i ? '' : item
            );
            setPackHeavyListClass(updatedPackageList);
            const updatedDocumentList = docHeavyListClass.map((item, index) =>
                index === i ? 'active' : item
            );
            setDocHeavyListClass(updatedDocumentList);
        }
    }

    const [countdiv, setcountdiv] = useState(1)
    const [countdiv_domestic, setcountdiv_domestic] = useState(1)
    const [countShipment, setCountShipment] = useState(1);

    function increment(val) {
        if (val == 'inter') {
            setcountdiv((prevCount) => prevCount + 1);

            const updatedData = { ...getQuotedata };
            updatedData.dimensions.height.push('0');
            updatedData.dimensions.length.push('0');
            updatedData.dimensions.width.push('0');
            updatedData.dimensions.weight.push('0.5');
            setgetQuotedata(updatedData);
        }
        else if (val == 'domestic') {
            setcountdiv_domestic((prevCount) => prevCount + 1);

            const updatedData = { ...getQuotedata_dom };
            updatedData.dimensions.height.push('0');
            updatedData.dimensions.length.push('0');
            updatedData.dimensions.width.push('0');
            updatedData.dimensions.weight.push('0.5');
            setgetQuotedata_dom(updatedData);
        }
        else if (val == "inter_shipment") {
            setCountShipment((prevCount) => prevCount + 1); // Increment the shipment count
            const updatedData = [...getQuotedatalist]; // Create a shallow copy of the existing data

            if (exportListClass[0] == "active") {
                updatedData.push({ // Use push to add a new item to the copied array
                    user: user,
                    origin: 'AE',
                    destination: 'GB',
                    shipmenttype: "exportdiv",
                    typediv: "package",
                    shipping_date: startDate,
                    dimensions: {
                        weight: ['0.5'],
                        length: ['0'],
                        width: ['0'],
                        height: ['0']
                    }
                });
                setgetQuotedatalist(updatedData);

                const updatedExportList = [...exportListClass]; // Create a shallow copy of the existing data
                updatedExportList.push('active');
                setExportListClass(updatedExportList);

                const updatedImportList = [...importListClass]; // Create a shallow copy of the existing data
                updatedImportList.push('');
                setImportListClass(updatedImportList);
            } else {
                updatedData.push({ // Use push to add a new item to the copied array
                    user: user,
                    origin: 'GB',
                    destination: 'AE',
                    shipmenttype: "importdiv",
                    typediv: "package",
                    shipping_date: startDate,
                    dimensions: {
                        weight: ['0.5'],
                        length: ['0'],
                        width: ['0'],
                        height: ['0']
                    }
                });
                setgetQuotedatalist(updatedData);

                const updatedExportList = [...exportListClass]; // Create a shallow copy of the existing data
                updatedExportList.push('');
                setExportListClass(updatedExportList);

                const updatedImportList = [...importListClass]; // Create a shallow copy of the existing data
                updatedImportList.push('active');
                setImportListClass(updatedImportList);
            }

            const updatedPackageList = [...packListClass]; // Create a shallow copy of the existing data
            updatedPackageList.push('active');
            setPackListClass(updatedPackageList);

            const updatedDocumentList = [...docListClass]; // Create a shallow copy of the existing data
            updatedDocumentList.push('');
            setDocListClass(updatedDocumentList);
        }
        else if (val == "heavy_shipment") {
            setHeavyCountShipment((prevCount) => prevCount + 1); // Increment the shipment count
            const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the existing data

            if (exportHeavyListClass[0] == 'active') {
                updatedData.push({ // Use push to add a new item to the copied array
                    user: user,
                    origin: 'AE',
                    destination: 'GB',
                    shipmenttype: "exportdiv",
                    typediv: "pallet",
                    shipping_date: startDate,
                    dimensions: {
                        weight: ['71'],
                        length: ['0'],
                        width: ['0'],
                        height: ['0']
                    }
                });
                setgetQuoteHeavydatalist(updatedData);

                const updatedExportList = [...exportHeavyListClass]; // Create a shallow copy of the existing data
                updatedExportList.push('active');
                setExportHeavyListClass(updatedExportList);

                const updatedImportList = [...importHeavyListClass]; // Create a shallow copy of the existing data
                updatedImportList.push('');
                setImportHeavyListClass(updatedImportList);
            } else {
                updatedData.push({ // Use push to add a new item to the copied array
                    user: user,
                    origin: 'GB',
                    destination: 'AE',
                    shipmenttype: "importdiv",
                    typediv: "package",
                    shipping_date: startDate,
                    dimensions: {
                        weight: ['71'],
                        length: ['0'],
                        width: ['0'],
                        height: ['0']
                    }
                });
                setgetQuoteHeavydatalist(updatedData);

                const updatedExportList = [...exportHeavyListClass]; // Create a shallow copy of the existing data
                updatedExportList.push('');
                setExportHeavyListClass(updatedExportList);

                const updatedImportList = [...importHeavyListClass]; // Create a shallow copy of the existing data
                updatedImportList.push('active');
                setImportHeavyListClass(updatedImportList);
            }

            const updatedPackageList = [...packHeavyListClass]; // Create a shallow copy of the existing data
            updatedPackageList.push('active');
            setPackHeavyListClass(updatedPackageList);

            const updatedDocumentList = [...docHeavyListClass]; // Create a shallow copy of the existing data
            updatedDocumentList.push('');
            setDocHeavyListClass(updatedDocumentList);
        }
    }

    function updateweight_dom(val, i) {
        setweightmsg(0)
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata_dom.dimensions };
        const updatedAccepted = [...clonedListing.weight]
        updatedAccepted[i] = val;
        setgetQuotedata_dom({
            ...getQuotedata_dom,
            dimensions: {
                ...clonedListing,
                weight: updatedAccepted
            }
        });
    }

    function updatelength_dom(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata_dom.dimensions };
        const updatedAccepted = [...clonedListing.length]
        updatedAccepted[i] = val;
        setgetQuotedata_dom({
            ...getQuotedata_dom,
            dimensions: {
                ...clonedListing,
                length: updatedAccepted
            }
        });
    }

    function updatewidth_dom(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata_dom.dimensions };
        const updatedAccepted = [...clonedListing.width]
        updatedAccepted[i] = val;
        setgetQuotedata_dom({
            ...getQuotedata_dom,
            dimensions: {
                ...clonedListing,
                width: updatedAccepted
            }
        });

    }

    function updateheight_dom(val, i,) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata_dom.dimensions };
        const updatedAccepted = [...clonedListing.height]
        updatedAccepted[i] = val;
        setgetQuotedata_dom({
            ...getQuotedata_dom,
            dimensions: {
                ...clonedListing,
                height: updatedAccepted
            }
        });

    }

    const [heavyCountShipment, setHeavyCountShipment] = useState(1);

    function removemore(val, shiptype) {
        if (shiptype == 'inter') {
            setcountdiv((prevCount) => prevCount - 1);
            const clonedListing = { ...getQuotedata.dimensions };
            const updatedAcceptedweight = [...clonedListing.weight]
            const updatedAcceptedlength = [...clonedListing.length]
            const updatedAcceptedwidth = [...clonedListing.width]
            const updatedAcceptedheight = [...clonedListing.height]
            updatedAcceptedweight.splice(val, 1);
            updatedAcceptedlength.splice(val, 1);
            updatedAcceptedwidth.splice(val, 1);
            updatedAcceptedheight.splice(val, 1);
            setgetQuotedata({
                ...getQuotedata,
                dimensions: {
                    ...clonedListing,
                    height: updatedAcceptedheight,
                    length: updatedAcceptedlength,
                    width: updatedAcceptedwidth,
                    weight: updatedAcceptedweight,
                }
            });
        }
        else if (shiptype == 'domestic') {
            setcountdiv_domestic((prevCount) => prevCount - 1);

            const clonedListing = { ...getQuotedata_dom.dimensions };
            const updatedAcceptedweight = [...clonedListing.weight]
            const updatedAcceptedlength = [...clonedListing.length]
            const updatedAcceptedwidth = [...clonedListing.width]
            const updatedAcceptedheight = [...clonedListing.height]
            updatedAcceptedweight.splice(val, 1);
            updatedAcceptedlength.splice(val, 1);
            updatedAcceptedwidth.splice(val, 1);
            updatedAcceptedheight.splice(val, 1);
            setgetQuotedata_dom({
                ...getQuotedata_dom,
                dimensions: {
                    ...clonedListing,
                    height: updatedAcceptedheight,
                    length: updatedAcceptedlength,
                    width: updatedAcceptedwidth,
                    weight: updatedAcceptedweight,
                }
            });
        } else if (shiptype == 'inter_shipment') {
            setCountShipment((prevCount) => prevCount - 1); // Decrease the shipment count
            const updatedData = getQuotedatalist.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setgetQuotedatalist(updatedData);

            let updateData1 = exportListClass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setExportListClass(updateData1);
            updateData1 = importListClass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setImportListClass(updateData1);
            updateData1 = packListClass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setPackListClass(updateData1);
            updateData1 = docListClass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setDocListClass(updateData1);
        } else if (shiptype == 'heavy_shipment') {
            setHeavyCountShipment((prevCount) => prevCount - 1); // Decrease the shipment count
            const updatedData = getQuoteHeavydatalist.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setgetQuoteHeavydatalist(updatedData);

            let updateData1 = exportHeavyListClass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setExportHeavyListClass(updateData1);
            updateData1 = importHeavyListClass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setImportHeavyListClass(updateData1);
            updateData1 = packHeavyListClass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setPackHeavyListClass(updateData1);
            updateData1 = docHeavyListClass.filter((_, index) => index !== val); // Create a new array excluding the item at index i
            setDocHeavyListClass(updateData1);
        }
    }

    async function getQuote(str) {
        console.log("??????????", str)
        if (str == "global") {
            console.log("---------", getQuotedata)
            try {
                const response = await fetch(`${BACKEND_URL}/quote`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        user: getQuotedata.user,
                        origin: getQuotedata.origin,
                        destination: getQuotedata.destination,
                        shipmenttype: getQuotedata.shipmenttype,
                        typediv: getQuotedata.typediv,
                        shipping_date: getQuotedata.shipping_date,
                        dimensions: getQuotedata.dimensions,
                    }),
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                sessionStorage.setItem('qouteinput', JSON.stringify(getQuotedata));
                console.log("---------", getQuotedata_dom, data);
                navigate('/quotation', {
                    state: {
                        basic: data.basic,
                        qoute_rate: data.rate,
                        get_gov_vat: data.charge1,
                        charge_rate: data.charge_rate,
                        es_surcharge: data.es_surcharge,
                        oversize: data.oversize,
                        er_charge: data.er_charge,
                        rd_charge: data.RD_charge,
                        user_discount: data.user_discount,
                        user_text: data.user_text,
                        weight: data.weight,
                        chargable_weight: data.chargable_weight,
                        get_transit_time: data.get_transit_time,
                        demand_surcharge: data.demand_surcharge,
                    },
                });
            } catch (error) {
                console.error(error.message);
            }
        } else if (str == "heavy") {
            const jsonArray = [];
            const fetchPromises = getQuoteHeavydatalist.map(async (item, index) => {
                try {
                    const response = await fetch(`${BACKEND_URL}/quoteMultiple`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            user: item.user,
                            origin: item.origin,
                            destination: item.destination,
                            shipmenttype: item.shipmenttype,
                            typediv: item.typediv,
                            shipping_date: item.shipping_date,
                            dimensions: item.dimensions,
                        }),
                    });
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();
                    jsonArray.push({
                        index: index,
                        basic: data.basic,
                        qoute_rate: data.rate,
                        get_gov_vat: data.charge1,
                        charge_rate: data.charge_rate,
                        es_surcharge: data.es_surcharge,
                        oversize: data.oversize,
                        er_charge: data.er_charge,
                        rd_charge: data.RD_charge,
                        user_discount: data.user_discount,
                        user_text: data.user_text,
                        weight: data.weight,
                        chargable_weight: data.chargable_weight,
                        get_transit_time: data.get_transit_time,
                        demand_surcharge: data.demand_surcharge,
                    });
                } catch (error) {
                    console.error(error.message);
                }
            });
            // Wait for all fetch promises to resolve
            await Promise.all(fetchPromises);

            jsonArray.sort((a, b) => a.index - b.index);
            sessionStorage.setItem('quoteheavyinput[]', JSON.stringify(getQuoteHeavydatalist));
            console.log("quoteheavyinput---------", getQuoteHeavydatalist, jsonArray);
            navigate('/quotationHeavyList', {
                state: jsonArray
            });
        } else if (str == "multiple") {

            console.log("multiple------", getQuotedatalist)
            const jsonArray = [];
            const fetchPromises = getQuotedatalist.map(async (item, index) => {
                try {
                    const response = await fetch(`${BACKEND_URL}/quote`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            user: item.user,
                            origin: item.origin,
                            destination: item.destination,
                            shipmenttype: item.shipmenttype,
                            typediv: item.typediv,
                            shipping_date: item.shipping_date,
                            dimensions: item.dimensions,
                        }),
                    });
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();
                    jsonArray.push({
                        index: index,
                        basic: data.basic,
                        qoute_rate: data.rate,
                        get_gov_vat: data.charge1,
                        charge_rate: data.charge_rate,
                        es_surcharge: data.es_surcharge,
                        oversize: data.oversize,
                        er_charge: data.er_charge,
                        rd_charge: data.RD_charge,
                        user_discount: data.user_discount,
                        user_text: data.user_text,
                        weight: data.weight,
                        chargable_weight: data.chargable_weight,
                        get_transit_time: data.get_transit_time,
                        demand_surcharge: data.demand_surcharge,
                    });
                } catch (error) {
                    console.error(error.message);
                }
            });
            // Wait for all fetch promises to resolve
            await Promise.all(fetchPromises);

            jsonArray.sort((a, b) => a.index - b.index);
            sessionStorage.setItem('qouteinput[]', JSON.stringify(getQuotedatalist));
            console.log("quotationList---------", getQuotedatalist, jsonArray);
            navigate('/quotationList', {
                state: jsonArray
            });
        }
    }

    function getQuoteDomestic() {
        fetch(`${BACKEND_URL}/quoteDomestic`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user: getQuotedata_dom.user,
                origin: getQuotedata_dom.origin,
                destination: getQuotedata_dom.destination,
                shipmenttype: getQuotedata_dom.shipmenttype,
                typediv: getQuotedata_dom.typediv,
                shipping_date: getQuotedata_dom.shipping_date,
                dimensions: getQuotedata_dom.dimensions,
                countryId: selectedCountry?.id, // Add countryId for backend to use correct country config
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                sessionStorage.setItem('qouteinput', JSON.stringify(getQuotedata_dom));
                navigate('/quotation', {
                    state: {
                        basic: data.basic,
                        qoute_rate: data.rate,
                        get_gov_vat: data.charge1,
                        charge_rate: data.charge_rate,
                        es_surcharge: data.es_surcharge,
                        oversize: data.oversize,
                        er_charge: data.er_charge,
                        rd_charge: data.RD_charge,
                        user_discount: data.user_discount,
                        user_text: data.user_text,
                        weight: data.weight,
                        chargable_weight: data.chargable_weight,
                        get_transit_time: data.get_transit_time,
                        demand_surcharge: data.demand_surcharge,
                    },
                });
            })
            .catch((error) => console.log(error.message))
    }

    function copySec(val) {
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAcceptedweight = [...clonedListing.weight]
        const updatedAcceptedlength = [...clonedListing.length]
        const updatedAcceptedwidth = [...clonedListing.width]
        const updatedAcceptedheight = [...clonedListing.height]
        updatedAcceptedweight[countdiv] = updatedAcceptedweight[val];
        updatedAcceptedlength[countdiv] = updatedAcceptedlength[val];
        updatedAcceptedwidth[countdiv] = updatedAcceptedwidth[val];
        updatedAcceptedheight[countdiv] = updatedAcceptedheight[val];
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                weight: updatedAcceptedweight,
                length: updatedAcceptedlength,
                width: updatedAcceptedwidth,
                height: updatedAcceptedheight
            }
        });
        setcountdiv((prevCount) => prevCount + 1);
    }

    function copySecDOM(val) {
        const clonedListing = { ...getQuotedata_dom.dimensions };
        const updatedAcceptedweight = [...clonedListing.weight]
        const updatedAcceptedlength = [...clonedListing.length]
        const updatedAcceptedwidth = [...clonedListing.width]
        const updatedAcceptedheight = [...clonedListing.height]
        updatedAcceptedweight[countdiv_domestic] = updatedAcceptedweight[val];
        updatedAcceptedlength[countdiv_domestic] = updatedAcceptedlength[val];
        updatedAcceptedwidth[countdiv_domestic] = updatedAcceptedwidth[val];
        updatedAcceptedheight[countdiv_domestic] = updatedAcceptedheight[val];
        setgetQuotedata_dom({
            ...getQuotedata_dom,
            dimensions: {
                ...clonedListing,
                weight: updatedAcceptedweight,
                length: updatedAcceptedlength,
                width: updatedAcceptedwidth,
                height: updatedAcceptedheight
            }
        });
        setcountdiv_domestic((prevCount) => prevCount + 1);
    }

    function setscheduledate(vars) {
        const updatedData = getQuotedatalist.map((item) => ({
            ...item, // Spread the existing properties of the item
            shipping_date: vars // Update the shipping_date property
        }));
        setgetQuotedatalist(updatedData);
        setStartDate(vars)
    }

    function setscheduledate2(vars) {
        setgetQuotedata_dom({ ...getQuotedata_dom, shipping_date: vars })
        setStartDate(vars)
    }

    return (
        <div>
            <Helmet>
                <title>Send A Parcel Worldwide At Affordable Rates</title>
            </Helmet>
            <div>
                <div className="quick-quote-home-bg">
                    <div className="img-container" style={{ backgroundColor: 'white', width: '100%', height: '847px' }}>
                        {/* <img src={banner} width={1349} height={847} /> */}
                    </div>
                </div>
                <div className="quick-quote-home">
                    <div className="tab-tittle-page">
                        <div style={{ height: '40px' }} />
                        <h1 className="h1-title">{title}</h1>

                    </div>
                    <div className="tab-quick-quote">
                        <div className="container">
                            <div style={{ height: '40px' }} />
                            <ul className="nav nav-tabs " id="myTab" role="tablist" style={{ minHeight: "auto" }}>
                                {fordomestic == 'international' ? (<>
                                    <li className="nav-item" role="presentation">
                                        <button onClick={() => changefun('in-package-document-tab')} className="nav-link active" id="in-package-document-tab" data-bs-toggle="tab" data-bs-target="#send_international_package_document" type="button" role="tab" aria-controls="send_international_package_document" aria-selected="true">Global Shipping</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link " onClick={() => changefun('uae-uae-tab')} id="uae-uae-tab" data-bs-toggle="tab" data-bs-target="#uae-uae" type="button" role="tab" aria-controls="uae-uae" aria-selected="false">UAE Domestic Shipping </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button onClick={() => changefun('multiple-shipments-tab')} className="nav-link" id="multiple-shipments-tab" data-bs-toggle="tab" data-bs-target="#multiple_shipments" type="button" role="tab" aria-controls="multiple_shipments" aria-selected="true">Multi-Origin & Multi-Destination Shipping </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button onClick={() => changefun('heavy-shipments-tab')} className="nav-link" id="heavy-shipments-tab" data-bs-toggle="tab" data-bs-target="#heavy_shipments" type="button" role="tab" aria-controls="heavy_shipments" aria-selected="true">Heavy Shipping </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <Link className="nav-link " to="/corporate-sme" id="corporate" type="button" aria-selected="false">Business & Bulk Shipping</Link>
                                    </li>
                                </>
                                ) : (
                                    <>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => changefun('in-package-document-tab')} className="nav-link " id="in-package-document-tab" data-bs-toggle="tab" data-bs-target="#send_international_package_document" type="button" role="tab" aria-controls="send_international_package_document" aria-selected="false">Global Shipping</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" onClick={() => changefun('uae-uae-tab')} id="uae-uae-tab" data-bs-toggle="tab" data-bs-target="#uae-uae" type="button" role="tab" aria-controls="uae-uae" aria-selected="true">UAE Domestic Shipping</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => changefun('multiple-shipments-tab')} className="nav-link" id="multiple-shipments-tab" data-bs-toggle="tab" data-bs-target="#multiple_shipments" type="button" role="tab" aria-controls="multiple_shipments" aria-selected="true">Multi-Origin & Multi-Destination Shipping </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button onClick={() => changefun('heavy-shipments-tab')} className="nav-link" id="heavy-shipments-tab" data-bs-toggle="tab" data-bs-target="#heavy_shipments" type="button" role="tab" aria-controls="heavy_shipments" aria-selected="true">Heavy Shipping </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <Link className="nav-link " to="/corporate-sme" id="corporate" type="button" aria-selected="false">Business & Bulk Shipping</Link>
                                        </li>
                                    </>
                                )}

                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className={`tab-pane fade ${makeactive}`} id="send_international_package_document" role="tabpanel" aria-labelledby="in-package-document-tab">
                                    <div className="container">
                                        <div className="row">
                                            {/* Send International Package */}
                                            <form action method="post" id="send-in-package" style={{ padding: 0 }}>
                                                <div className="quick-holder">
                                                    <div className="col-md-5 col-sm-5">
                                                        <h3 className="section-head">Where are you sending your parcels from/to?</h3>
                                                        <div className="tab-in-export-import" style={{ display: "flex", alignItems: "center" }}>
                                                            <div style={{ width: "50%" }}>
                                                                <div>
                                                                    <label>Shipment Direction:</label>
                                                                </div>
                                                                <a onClick={() => showthisdiv('exportdiv')} style={{ cursor: 'pointer' }} className={`export-link in-send-package ${exportclass}`} id="export-link-ip">Export</a>
                                                                <a onClick={() => showthisdiv('importdiv')} style={{ cursor: 'pointer' }} className={`import-link in-send-package  ${importclass}`} id="import-link-ip">Import</a>
                                                            </div>
                                                            <div style={{ width: "50%" }}>
                                                                <div>
                                                                    <label>Type of Shipment:</label>
                                                                </div>
                                                                <div>
                                                                    <a onClick={() => showtypediv('package')} style={{ cursor: 'pointer' }} className={`export-link in-send-package ${packclass}`} id="package-link">Package</a>
                                                                    <a onClick={() => showtypediv('document')} style={{ cursor: 'pointer' }} className={`import-link in-send-package ${docclass}`} id="document-link">Document</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* International Export Package */}
                                                        {showdiv && showdiv == 'exportdiv' ? (
                                                            <div className="tab-in-export-package">
                                                                <ul className="in-export-package from-to">
                                                                    <li>
                                                                        <label>From</label>
                                                                        <select className="form-select select-export-package" name="delivery_from" onChange={(e) => setgetQuotedata({ ...getQuotedata, origin: e.target.value })}>
                                                                            <option value="AE">Abu Dhabi</option>
                                                                            <option value="AE">Ajman</option>
                                                                            <option value="AE">Al Ain</option>
                                                                            <option value="AE" selected >Dubai</option>
                                                                            <option value="AE">Fujairah</option>
                                                                            <option value="AE">Ras Al Khaimah</option>
                                                                            <option value="AE">Sharjah</option>
                                                                            <option value="AE">Umm Al Quwain</option>
                                                                        </select>
                                                                    </li>
                                                                    <li>
                                                                        <label>To</label>
                                                                        <select className="form-select select-export-package" name="delivery_to" onChange={(e) => setgetQuotedata({ ...getQuotedata, destination: e.target.value })}>
                                                                            {

                                                                                Object.entries(countries).map(([k, v]) => (
                                                                                    <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                ))
                                                                            }

                                                                        </select>

                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null
                                                        }
                                                        {/* End International Export Package */}
                                                        {/* International Import Package */}
                                                        {showdiv && showdiv == 'importdiv' ? (


                                                            <div className="tab-in-import-package" >
                                                                <ul className="in-import-package from-to">
                                                                    <li>
                                                                        <label>From</label>
                                                                        <select className="form-select select-export-package" name="delivery_to" onChange={(e) => setgetQuotedata({ ...getQuotedata, origin: e.target.value })}>
                                                                            {

                                                                                Object.entries(countries).map(([k, v]) => (
                                                                                    <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                ))
                                                                            }

                                                                        </select>
                                                                    </li>
                                                                    <li>
                                                                        <label>To</label>
                                                                        <select className="form-select select-export-package" name="delivery_from" onChange={(e) => setgetQuotedata({ ...getQuotedata, destination: e.target.value })}>
                                                                            <option value="AE">Abu Dhabi</option>
                                                                            <option value="AE">Ajman</option>
                                                                            <option value="AE">Al Ain</option>
                                                                            <option value="AE" selected >Dubai</option>
                                                                            <option value="AE">Fujairah</option>
                                                                            <option value="AE">Ras Al Khaimah</option>
                                                                            <option value="AE">Sharjah</option>
                                                                            <option value="AE">Umm Al Quwain</option>
                                                                        </select>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null
                                                        }
                                                        {/* End International Import Package */}
                                                    </div>
                                                    <div className="col-md-7 col-sm-7">
                                                        <div id="add_more_weight_package_in" className="add_more_weight">
                                                            {[...Array(countdiv)].map((e, i) => <><div key={i}>
                                                                <h3 className="section-head">Enter the weight and dimensions of your parcels {i > 0 ? (
                                                                    <button type="button" className="removebtn" onClick={() => removemore(i, 'inter')}>x</button>
                                                                ) : null} </h3>
                                                                <div className="weight-section">
                                                                    <ul className="in-export-package from-to">

                                                                        {typediv && typediv == 'package' ? (
                                                                            <li>
                                                                                <label>Weight* ({weightUnit})</label>
                                                                                <select className="form-select" name="weight[]" onChange={(e) => updateweight(e.target.value, i)}>
                                                                                    {/* <select className="form-select" name="weight[]" onChange={(e)=>setgetQuotedata({...getQuotedata,weight:e.target.value})}> */}
                                                                                    {/* <select className="form-select" name="weight[]"  onChange={(e)=>updateweight(e.target.value,'')}> */}
                                                                                    {i > 0 ? (
                                                                                        <option value="">select weight</option>
                                                                                    ) : null
                                                                                    }
                                                                                    <option value="0.5" selected={getQuotedata.dimensions.weight[i] === '0.5'} >0.5</option>
                                                                                    <option value="1" selected={getQuotedata.dimensions.weight[i] === '1'}>1</option>
                                                                                    <option value="1.5" selected={getQuotedata.dimensions.weight[i] === '1.5'}>1.5</option>
                                                                                    <option value="2" selected={getQuotedata.dimensions.weight[i] === '2'}>2</option>
                                                                                    <option value="2.5" selected={getQuotedata.dimensions.weight[i] === '2.5'}>2.5</option>
                                                                                    <option value="3" selected={getQuotedata.dimensions.weight[i] === '3'}>3</option>
                                                                                    <option value="3.5" selected={getQuotedata.dimensions.weight[i] === '3.5'}>3.5</option>
                                                                                    <option value="4" selected={getQuotedata.dimensions.weight[i] === '4'}>4</option>
                                                                                    <option value="4.5" selected={getQuotedata.dimensions.weight[i] === '4.5'} >4.5</option>
                                                                                    <option value="5" selected={getQuotedata.dimensions.weight[i] === '5'}>5</option>
                                                                                    <option value="5.5" selected={getQuotedata.dimensions.weight[i] === '5.5'}>5.5</option>
                                                                                    <option value="6" selected={getQuotedata.dimensions.weight[i] === '6'}>6</option>
                                                                                    <option value="6.5" selected={getQuotedata.dimensions.weight[i] === '6.5'}>6.5</option>
                                                                                    <option value="7" selected={getQuotedata.dimensions.weight[i] === '7'}>7</option>
                                                                                    <option value="7.5" selected={getQuotedata.dimensions.weight[i] === '7.5'}>7.5</option>
                                                                                    <option value="8" selected={getQuotedata.dimensions.weight[i] === '8'}>8</option>
                                                                                    <option value="8.5" selected={getQuotedata.dimensions.weight[i] === '8.5'} >8.5</option>
                                                                                    <option value="9" selected={getQuotedata.dimensions.weight[i] === '9'}>9</option>
                                                                                    <option value="9.5" selected={getQuotedata.dimensions.weight[i] === '9.5'}>9.5</option>

                                                                                    {[...Array(71)].map((x, k) => (
                                                                                        k > 9 ? (
                                                                                            <option value={k} selected={getQuotedata.dimensions.weight[i] == k} key={k} >{k}</option>
                                                                                        ) : null
                                                                                    )
                                                                                    )}
                                                                                </select>
                                                                            </li>
                                                                        ) : <li>
                                                                            <label>Weight* ({weightUnit})</label>
                                                                            <select className="form-select" name="weight[]" onChange={(e) => updateweight(e.target.value, i)}>
                                                                                {i > 0 ? (
                                                                                    <option value="">select weight</option>
                                                                                ) : null
                                                                                }
                                                                                <option value="0.5" selected={getQuotedata.dimensions.weight[i] === '0.5'}>0.5</option>
                                                                                <option value="1" selected={getQuotedata.dimensions.weight[i] === '1'}>1</option>
                                                                                <option value="1.5" selected={getQuotedata.dimensions.weight[i] === '1.5'}>1.5</option>
                                                                                <option value="2" selected={getQuotedata.dimensions.weight[i] === '2'}>2</option>
                                                                            </select>
                                                                        </li>
                                                                        }

                                                                        <li>
                                                                            <label>Length ({dimensionUnit})</label>
                                                                            <input className="form-control" name="length[]" value={getQuotedata.dimensions.length[i]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updatelength(e.target.value, i)}
                                                                                onKeyPress={(e) => {
                                                                                    const charCode = e.which ? e.which : e.keyCode;
                                                                                    // Allow only numbers (0-9) and control keys (like backspace)
                                                                                    if ((charCode < 48 || charCode > 57)) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </li>
                                                                        <li>
                                                                            <label>Width ({dimensionUnit})</label>
                                                                            <input className="form-control" name="width[]" value={getQuotedata.dimensions.width[i]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updatewidth(e.target.value, i)}
                                                                                onKeyPress={(e) => {
                                                                                    const charCode = e.which ? e.which : e.keyCode;
                                                                                    // Allow only numbers (0-9) and control keys (like backspace)
                                                                                    if ((charCode < 48 || charCode > 57)) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </li>
                                                                        <li>
                                                                            <label>Height ({dimensionUnit})</label>
                                                                            <input className="form-control" name="height[]" value={getQuotedata.dimensions.height[i]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updateheight(e.target.value, i)}
                                                                                onKeyPress={(e) => {
                                                                                    const charCode = e.which ? e.which : e.keyCode;
                                                                                    // Allow only numbers (0-9) and control keys (like backspace)
                                                                                    if ((charCode < 48 || charCode > 57)) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </li>
                                                                        <a title='Duplicate this package’s info' className="copybtn" onClick={() => copySec(i)}>+</a>
                                                                    </ul>
                                                                    {
                                                                        weightmsg && weightmsg == 1 ? (
                                                                            <>
                                                                                <p style={{ fontSize: '16px', fontWeight: 'bold', lineHeight: '8px' }}>Please contact us for rates</p>
                                                                                <p style={{ fontSize: '16px', fontWeight: 'bold', paddingBottom: '5%' }}>Email: <span style={{ color: '#3c50e0' }}><a style={{ color: '#3c50e0' }} href="mailto:info@timexpress.ae?subject=Shypv Enquiry">sales@timexpress.ae</a></span>&nbsp;&nbsp; Phone: <span style={{ color: '#3c50e0' }}><a href="tel:600503327" style={{ textDecoration: 'none', color: '#3c50e0' }}>600503327</a></span></p>
                                                                            </>
                                                                        ) : null
                                                                    }
                                                                </div>
                                                            </div>
                                                            </>
                                                            )
                                                            }

                                                        </div>
                                                        <button onClick={() => increment('inter')} className="btn btn-primary btn-parcels add-btn add_more_sizes" id="in_package" type="button" >Add another package </button>
                                                    </div>
                                                </div>
                                                <hr className="hr_border" />
                                                <div className="container date_ship">
                                                    <div className="row">
                                                        <div className="col-md-8 col-sm-8">
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6">
                                                                    <h3 className="section-head"><mark>When are you shipping?</mark></h3>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6">
                                                                    <DatePicker className="form-control shipping_date" filterDate={isWeekday} name="shipping_date" dateFormat='dd/MM/yyyy' minDate={startDate2} selected={startDate} onChange={(date) => setscheduledate(date)} />

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-sm-4">
                                                            <div className="wrape_promo" style={{ textAlign: 'center' }}>
                                                                <span className="get_center_bnts">
                                                                    {weightmsg && weightmsg == 1 ? (
                                                                        <button className="btn btn-primary" type="button" name="get_quotes" id="get_quote" flag="package" disabled onClick={() => getQuote("global")}>Get Quote</button>
                                                                    ) : (
                                                                        <button className="btn btn-primary" type="button" name="get_quotes" id="get_quote" flag="package" onClick={() => getQuote("global")}>Get Quote</button>
                                                                    )}

                                                                    <input type="hidden" name="get_quote" defaultValue="Get Quote" />
                                                                    <input type="hidden" name="parcel_type" id="in_parcel_type" defaultValue="export" />
                                                                    <input type="hidden" name="pac_type" id="pac-pac-link" defaultValue="package" />
                                                                    <input type="hidden" name="promo_discount" defaultValue id="promo_discount" />
                                                                </span>
                                                                {/* <div class="yodeldirect-hedding"><h3>Temporary Out of Service</h3></div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tab-pane fade ${makeactivedom}`} id="uae-uae" role="tabpanel" aria-labelledby="uae-uae-tab">
                                    <div className="container">
                                        <div className="row">
                                            {/* UAE Domestic Shipping */}
                                            <form action method="post" id="send-uae-to-uae" style={{ padding: 0 }}>
                                                <div className="quick-holder">
                                                    <div className="col-md-5 col-sm-5">
                                                        <h3 className="section-head">Where are you sending your parcels from/to?</h3>
                                                        <div className="tab-in-export-import">
                                                            <a href="" className="export-link uae-to-uae active" id="export-link-freight">Next Day</a>
                                                        </div>
                                                        <div className="tab-uae-to-uae">
                                                            <ul className="in-export-freight from-to">
                                                                <li>
                                                                    <label>From</label>
                                                                    <select className="form-select select-uae-to-uae" name="delivery_from" onChange={(e) => setgetQuotedata_dom({ ...getQuotedata_dom, origin: e.target.value })}>
                                                                        {citiesToCollect.map((city, index) => {
                                                                            // Map city names to codes
                                                                            const cityCode = city.toLowerCase().includes('dubai') ? 'DXB' : 
                                                                                           city.toLowerCase().includes('abu') ? 'AUH' : 
                                                                                           city.toLowerCase().includes('sharjah') ? 'SHJ' : 
                                                                                           city.substring(0, 3).toUpperCase();
                                                                            return <option key={index} value={cityCode} selected={index === 0}>{city}</option>
                                                                        })}
                                                                    </select>
                                                                </li>
                                                                <li>
                                                                    <label>To</label>
                                                                    <select className="form-select select-uae-to-uae" name="delivery_to" onChange={(e) => setgetQuotedata_dom({ ...getQuotedata_dom, destination: e.target.value })}>
                                                                        {

                                                                            Object.entries(domesticloc).map(([k, v]) => (
                                                                                <option key={k} value={k} selected={k === 'AUH'}>{v}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>


                                                    <div className="col-md-7 col-sm-7"  >
                                                        <div id="add_more_weight_uae_to_uae" className="add_more_weight">
                                                            {[...Array(countdiv_domestic)].map((e, i) => <><div key={i}>
                                                                <h3 className="section-head">Enter the weight and dimensions of your parcels {i > 0 ? (
                                                                    <button type="button" className="removebtn" onClick={() => removemore(i, 'domestic')}>x</button>
                                                                ) : null} </h3>
                                                                <div className="weight-section">
                                                                    <ul className="uae-to-uae from-to">

                                                                        <li>
                                                                            <label>Weight* (kg)</label>
                                                                            <select className="form-select" name="weight[]" onChange={(e) => updateweight_dom(e.target.value, i)}>
                                                                                <option value="0.5" selected={getQuotedata_dom.dimensions.weight[i] === '0.5'} >0.5</option>
                                                                                <option value="1" selected={getQuotedata_dom.dimensions.weight[i] === '1'}>1</option>
                                                                                <option value="1.5" selected={getQuotedata_dom.dimensions.weight[i] === '1.5'}>1.5</option>
                                                                                <option value="2" selected={getQuotedata_dom.dimensions.weight[i] === '2'}>2</option>
                                                                                <option value="2.5" selected={getQuotedata_dom.dimensions.weight[i] === '2.5'}>2.5</option>
                                                                                <option value="3" selected={getQuotedata_dom.dimensions.weight[i] === '3'}>3</option>
                                                                                <option value="3.5" selected={getQuotedata_dom.dimensions.weight[i] === '3.5'}>3.5</option>
                                                                                <option value="4" selected={getQuotedata_dom.dimensions.weight[i] === '4'}>4</option>
                                                                                <option value="4.5" selected={getQuotedata_dom.dimensions.weight[i] === '4.5'} >4.5</option>
                                                                                <option value="5" selected={getQuotedata_dom.dimensions.weight[i] === '5'}>5</option>
                                                                                <option value="5.5" selected={getQuotedata_dom.dimensions.weight[i] === '5.5'}>5.5</option>
                                                                                <option value="6" selected={getQuotedata_dom.dimensions.weight[i] === '6'}>6</option>
                                                                                <option value="6.5" selected={getQuotedata_dom.dimensions.weight[i] === '6.5'}>6.5</option>
                                                                                <option value="7" selected={getQuotedata_dom.dimensions.weight[i] === '7'}>7</option>
                                                                                <option value="7.5" selected={getQuotedata_dom.dimensions.weight[i] === '7.5'}>7.5</option>
                                                                                <option value="8" selected={getQuotedata_dom.dimensions.weight[i] === '8'}>8</option>
                                                                                <option value="8.5" selected={getQuotedata_dom.dimensions.weight[i] === '8.5'} >8.5</option>
                                                                                <option value="9" selected={getQuotedata_dom.dimensions.weight[i] === '9'}>9</option>
                                                                                <option value="9.5" selected={getQuotedata_dom.dimensions.weight[i] === '9.5'}>9.5</option>

                                                                                {[...Array(71)].map((x, z) => (
                                                                                    z > 9 ? (
                                                                                        <option value={z} key={z} selected={getQuotedata_dom.dimensions.weight[i] === z}>{z}</option>
                                                                                    ) : null

                                                                                )
                                                                                )}
                                                                            </select>
                                                                        </li>
                                                                        <li>
                                                                            <label>Length (cm)</label>
                                                                            <input className="form-control" name="length[]" value={getQuotedata_dom.dimensions.length[i]} placeholder type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updatelength_dom(e.target.value, i)}
                                                                                onKeyPress={(e) => {
                                                                                    const charCode = e.which ? e.which : e.keyCode;
                                                                                    // Allow only numbers (0-9) and control keys (like backspace)
                                                                                    if ((charCode < 48 || charCode > 57)) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </li>
                                                                        <li>
                                                                            <label>Width ({dimensionUnit})</label>
                                                                            <input className="form-control" name="width[]" value={getQuotedata_dom.dimensions.width[i]} placeholder type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updatewidth_dom(e.target.value, i)}
                                                                                onKeyPress={(e) => {
                                                                                    const charCode = e.which ? e.which : e.keyCode;
                                                                                    // Allow only numbers (0-9) and control keys (like backspace)
                                                                                    if ((charCode < 48 || charCode > 57)) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </li>
                                                                        <li>
                                                                            <label>Height ({dimensionUnit})</label>
                                                                            <input className="form-control" name="height[]" value={getQuotedata_dom.dimensions.height[i]} placeholder type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updateheight_dom(e.target.value, i)}
                                                                                onKeyPress={(e) => {
                                                                                    const charCode = e.which ? e.which : e.keyCode;
                                                                                    // Allow only numbers (0-9) and control keys (like backspace)
                                                                                    if ((charCode < 48 || charCode > 57)) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </li>
                                                                        <a title='Duplicate this package’s info' className="copybtn" onClick={() => copySecDOM(i)}>+</a>
                                                                    </ul>

                                                                </div>

                                                            </div>
                                                            </>
                                                            )}

                                                            <button onClick={() => increment('domestic')} className="btn btn-primary btn-parcels add-btn add_more_sizes" id="uae_to_uae" type="button" data-toggle="collapse" data-target="#collapseExample1" aria-expanded="false" aria-controls="collapseExample1">Add another package</button>
                                                        </div>
                                                    </div>

                                                </div>
                                                <hr className="hr_border" />
                                                <div className="container date_ship">
                                                    <div className="row">
                                                        <div className="col-md-8 col-sm-8">
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6">
                                                                    <h3 className="section-head"><mark>When are you shipping?</mark></h3>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6">
                                                                    <DatePicker className="form-control shipping_date" filterDate={isWeekday} name="shipping_date" dateFormat='dd/MM/yyyy' minDate={startDate2} selected={startDate} onChange={(date) => setscheduledate2(date)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-sm-4">
                                                            <div className="wrape_promo" style={{ textAlign: 'center' }}>
                                                                <span className="get_center_bnts">
                                                                    <button className="btn btn-primary" type="button" name="get_quotes" id="get_quote" flag="freight" onClick={getQuoteDomestic}>Get Quote</button>
                                                                    <input type="hidden" name="get_quote" defaultValue="Get Quote" />
                                                                    <input type="hidden" name="parcel_type" id="uae_parcel_type" defaultValue="nextday" />
                                                                    <input type="hidden" name="promo_discount" defaultValue id="promo_discount" />
                                                                </span>
                                                                {/* <div class="yodeldirect-hedding"><h3>Temporary Out of Service</h3></div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            {/* End UAE Domestic Shipping */}
                                        </div>
                                    </div>
                                </div>

                                <div className={`tab-pane fade`} id="multiple_shipments" role="tabpanel" aria-labelledby="multiple-shipments-tab">
                                    <div className="container">
                                        <div className="row">
                                            <form action method="post" id="multiple_shipments" style={{ padding: 0 }}>
                                                <>
                                                    {[...Array(countShipment)].map((e, i) =>
                                                        <div className="quick-holder">
                                                            <div className="col-md-5 col-sm-5">
                                                                <h3 className="section-head">Where are you sending your parcels from/to?</h3>
                                                                <div className="tab-in-export-import" style={{ display: "flex", alignItems: "center" }}>
                                                                    <div style={{ width: "50%" }}>
                                                                        <div>
                                                                            <label>Shipment Direction:</label>
                                                                        </div>
                                                                        <a onClick={() => showthisdivlist('exportdiv', i)} style={{ cursor: 'pointer' }} className={`export-link in-send-package ${exportListClass[i]}`} id="export-link-ip">Export</a>
                                                                        <a onClick={() => showthisdivlist('importdiv', i)} style={{ cursor: 'pointer' }} className={`import-link in-send-package  ${importListClass[i]}`} id="import-link-ip">Import</a>
                                                                    </div>
                                                                    <div style={{ width: "50%" }}>
                                                                        <div>
                                                                            <label>Type of Shipment:</label>
                                                                        </div>
                                                                        <div>
                                                                            <a onClick={() => showtypedivlist('package', i)} style={{ cursor: 'pointer' }} className={`export-link in-send-package ${packListClass[i]}`} id="package-link">Package</a>
                                                                            <a onClick={() => showtypedivlist('document', i)} style={{ cursor: 'pointer' }} className={`import-link in-send-package ${docListClass[i]}`} id="document-link">Document</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* International Export Package */}
                                                                {getQuotedatalist[i].shipmenttype && getQuotedatalist[i].shipmenttype == 'exportdiv' ? (
                                                                    <div className="tab-in-export-package">
                                                                        <ul className="in-export-package from-to">
                                                                            <li>
                                                                                <label>From</label>
                                                                                <select
                                                                                    className="form-select select-export-package"
                                                                                    name="delivery_from"
                                                                                    onChange={(e) => {
                                                                                        const updatedData = [...getQuotedatalist]; // Create a shallow copy of the array
                                                                                        updatedData.map((item, index) => {
                                                                                            if (index == i) {
                                                                                                item.origin = e.target.value;
                                                                                                return item;
                                                                                            } else {
                                                                                                return item;
                                                                                            }
                                                                                        });
                                                                                        setgetQuotedatalist(updatedData); // Update the state with the new array
                                                                                    }}
                                                                                >
                                                                                    <option value="AE">Abu Dhabi</option>
                                                                                    <option value="AE">Ajman</option>
                                                                                    <option value="AE">Al Ain</option>
                                                                                    <option value="AE" selected >Dubai</option>
                                                                                    <option value="AE">Fujairah</option>
                                                                                    <option value="AE">Ras Al Khaimah</option>
                                                                                    <option value="AE">Sharjah</option>
                                                                                    <option value="AE">Umm Al Quwain</option>
                                                                                </select>
                                                                            </li>
                                                                            <li>
                                                                                <label>To</label>
                                                                                <select
                                                                                    className="form-select select-export-package"
                                                                                    name="delivery_to"
                                                                                    onChange={(e) => {
                                                                                        const updatedData = [...getQuotedatalist]; // Create a shallow copy of the array
                                                                                        updatedData[i] = { ...updatedData[i], destination: e.target.value }; // Update the specific object's origin
                                                                                        setgetQuotedatalist(updatedData); // Update the state with the new array
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        Object.entries(countries).map(([k, v]) => (
                                                                                            <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                ) : null
                                                                }
                                                                {/* End International Export Package */}
                                                                {/* International Import Package */}
                                                                {getQuotedatalist[i].shipmenttype && getQuotedatalist[i].shipmenttype == 'importdiv' ? (
                                                                    <div className="tab-in-import-package" >
                                                                        <ul className="in-import-package from-to">
                                                                            <li>
                                                                                <label>From</label>
                                                                                <select
                                                                                    className="form-select select-export-package"
                                                                                    name="delivery_to"
                                                                                    onChange={(e) => {
                                                                                        console.log(e.target.value);
                                                                                        const updatedData = [...getQuotedatalist];
                                                                                        updatedData.map((item, index) => {
                                                                                            if (index == i) {
                                                                                                item.origin = e.target.value;
                                                                                                return item;
                                                                                            } else return item;
                                                                                        });
                                                                                        console.log(updatedData);
                                                                                        setgetQuotedatalist(updatedData); // Update the state with the new array
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        Object.entries(countries).map(([k, v]) => (
                                                                                            <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                            </li>
                                                                            <li>
                                                                                <label>To</label>
                                                                                <select
                                                                                    className="form-select select-export-package"
                                                                                    name="delivery_from"
                                                                                    onChange={(e) => {
                                                                                        const updatedData = [...getQuotedatalist]; // Create a shallow copy of the array
                                                                                        updatedData[i] = { ...updatedData[i], destination: e.target.value }; // Update the specific object's origin
                                                                                        setgetQuotedatalist(updatedData); // Update the state with the new array
                                                                                    }}
                                                                                >
                                                                                    <option value="AE">Abu Dhabi</option>
                                                                                    <option value="AE">Ajman</option>
                                                                                    <option value="AE">Al Ain</option>
                                                                                    <option value="AE" selected >Dubai</option>
                                                                                    <option value="AE">Fujairah</option>
                                                                                    <option value="AE">Ras Al Khaimah</option>
                                                                                    <option value="AE">Sharjah</option>
                                                                                    <option value="AE">Umm Al Quwain</option>
                                                                                </select>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                ) : null
                                                                }
                                                                {/* End International Import Package */}
                                                            </div>
                                                            <div className="col-md-7 col-sm-7">
                                                                <div id="add_more_weight_package_in" className="add_more_weight">
                                                                    <div key={i}>
                                                                        <h3 className="section-head">Enter the weight and dimensions of your parcels {i > 0 ? (
                                                                            <button type="button" className="removebtn" onClick={() => removemore(i, 'inter_shipment')}>x</button>
                                                                        ) : null} </h3>
                                                                        <div className="weight-section">
                                                                            <ul className="in-export-package from-to">

                                                                                {getQuotedatalist[i].typediv && getQuotedatalist[i].typediv == 'package' ? (
                                                                                    <li>
                                                                                        <label>Weight* (kg)</label>
                                                                                        <select className="form-select" name="weight[]" onChange={(e) => updateweightlist(e.target.value, i)}>
                                                                                            {i > 0 ? (
                                                                                                <option value="">select weight</option>
                                                                                            ) : null
                                                                                            }
                                                                                            <option value="0.5" selected={getQuotedatalist[i].dimensions.weight[0] === '0.5'} >0.5</option>
                                                                                            <option value="1" selected={getQuotedatalist[i].dimensions.weight[0] === '1'}>1</option>
                                                                                            <option value="1.5" selected={getQuotedatalist[i].dimensions.weight[0] === '1.5'}>1.5</option>
                                                                                            <option value="2" selected={getQuotedatalist[i].dimensions.weight[0] === '2'}>2</option>
                                                                                            <option value="2.5" selected={getQuotedatalist[i].dimensions.weight[0] === '2.5'}>2.5</option>
                                                                                            <option value="3" selected={getQuotedatalist[i].dimensions.weight[0] === '3'}>3</option>
                                                                                            <option value="3.5" selected={getQuotedatalist[i].dimensions.weight[0] === '3.5'}>3.5</option>
                                                                                            <option value="4" selected={getQuotedatalist[i].dimensions.weight[0] === '4'}>4</option>
                                                                                            <option value="4.5" selected={getQuotedatalist[i].dimensions.weight[0] === '4.5'} >4.5</option>
                                                                                            <option value="5" selected={getQuotedatalist[i].dimensions.weight[0] === '5'}>5</option>
                                                                                            <option value="5.5" selected={getQuotedatalist[i].dimensions.weight[0] === '5.5'}>5.5</option>
                                                                                            <option value="6" selected={getQuotedatalist[i].dimensions.weight[0] === '6'}>6</option>
                                                                                            <option value="6.5" selected={getQuotedatalist[i].dimensions.weight[0] === '6.5'}>6.5</option>
                                                                                            <option value="7" selected={getQuotedatalist[i].dimensions.weight[0] === '7'}>7</option>
                                                                                            <option value="7.5" selected={getQuotedatalist[i].dimensions.weight[0] === '7.5'}>7.5</option>
                                                                                            <option value="8" selected={getQuotedatalist[i].dimensions.weight[0] === '8'}>8</option>
                                                                                            <option value="8.5" selected={getQuotedatalist[i].dimensions.weight[0] === '8.5'} >8.5</option>
                                                                                            <option value="9" selected={getQuotedatalist[i].dimensions.weight[0] === '9'}>9</option>
                                                                                            <option value="9.5" selected={getQuotedatalist[i].dimensions.weight[0] === '9.5'}>9.5</option>

                                                                                            {[...Array(71)].map((x, k) => (
                                                                                                k > 9 ? (
                                                                                                    <option value={k} selected={getQuotedatalist[i].dimensions.weight[0] == k} key={k} >{k}</option>
                                                                                                ) : null
                                                                                            )
                                                                                            )}
                                                                                        </select>
                                                                                    </li>
                                                                                ) : <li>
                                                                                    <label>Weight* (kg)</label>
                                                                                    <select className="form-select" name="weight[]" onChange={(e) => updateweightlist(e.target.value, i)}>
                                                                                        {i > 0 ? (
                                                                                            <option value="">select weight</option>
                                                                                        ) : null
                                                                                        }
                                                                                        <option value="0.5" selected={getQuotedatalist[i].dimensions.weight[0] === '0.5'}>0.5</option>
                                                                                        <option value="1" selected={getQuotedatalist[i].dimensions.weight[0] === '1'}>1</option>
                                                                                        <option value="1.5" selected={getQuotedatalist[i].dimensions.weight[0] === '1.5'}>1.5</option>
                                                                                        <option value="2" selected={getQuotedatalist[i].dimensions.weight[0] === '2'}>2</option>
                                                                                    </select>
                                                                                </li>
                                                                                }
                                                                                <li>
                                                                                    <label>Length (cm)</label>
                                                                                    <input className="form-control" name="length[]" value={getQuotedatalist[i].dimensions.length[0]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updatelengthlist(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                                <li>
                                                                                    <label>Width ({dimensionUnit})</label>
                                                                                    <input className="form-control" name="width[]" value={getQuotedatalist[i].dimensions.width[0]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updatewidthlist(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                                <li>
                                                                                    <label>Height ({dimensionUnit})</label>
                                                                                    <input className="form-control" name="height[]" value={getQuotedatalist[i].dimensions.height[0]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updateheightlist(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                            </ul>
                                                                            {
                                                                                weightmsg && weightmsg == 1 ? (
                                                                                    <>
                                                                                        <p style={{ fontSize: '16px', fontWeight: 'bold', lineHeight: '8px' }}>Please contact us for rates</p>
                                                                                        <p style={{ fontSize: '16px', fontWeight: 'bold', paddingBottom: '5%' }}>Email: <span style={{ color: '#3c50e0' }}><a style={{ color: '#3c50e0' }} href="mailto:info@timexpress.ae?subject=Shypv Enquiry">sales@timexpress.ae</a></span>&nbsp;&nbsp; Phone: <span style={{ color: '#3c50e0' }}><a href="tel:600503327" style={{ textDecoration: 'none', color: '#3c50e0' }}>600503327</a></span></p>
                                                                                    </>
                                                                                ) : null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    countShipment == (i + 1) ? (
                                                                        <button onClick={() => increment('inter_shipment')} className="btn btn-primary btn-parcels add-btn add_more_sizes" id="in_package" type="button" >Add another shipment </button>
                                                                    ) : null
                                                                }
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                                <hr className="hr_border" />
                                                <div className="container date_ship">
                                                    <div className="row">
                                                        <div className="col-md-8 col-sm-8">
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6">
                                                                    <h3 className="section-head"><mark>When are you shipping?</mark></h3>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6">
                                                                    <DatePicker className="form-control shipping_date" filterDate={isWeekday} name="shipping_date" dateFormat='dd/MM/yyyy' minDate={startDate2} selected={startDate} onChange={(date) => setscheduledate(date)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-sm-4">
                                                            <div className="wrape_promo" style={{ textAlign: 'center' }}>
                                                                <span className="get_center_bnts">
                                                                    {weightmsg && weightmsg == 1 ? (
                                                                        <button className="btn btn-primary" type="button" name="get_quotes" id="get_quote" flag="package" disabled onClick={() => getQuote("multiple")}>Get Quote</button>
                                                                    ) : (
                                                                        <button className="btn btn-primary" type="button" name="get_quotes" id="get_quote" flag="package" onClick={() => getQuote("multiple")}>Get Quote</button>
                                                                    )}

                                                                    <input type="hidden" name="get_quote" defaultValue="Get Quote" />
                                                                    <input type="hidden" name="parcel_type" id="in_parcel_type" defaultValue="export" />
                                                                    <input type="hidden" name="pac_type" id="pac-pac-link" defaultValue="package" />
                                                                    <input type="hidden" name="promo_discount" defaultValue id="promo_discount" />
                                                                </span>
                                                                {/* <div class="yodeldirect-hedding"><h3>Temporary Out of Service</h3></div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tab-pane fade`} id="heavy_shipments" role="tabpanel" aria-labelledby="heavy-shipments-tab">
                                    <div className="container">
                                        <div className="row">
                                            <form action method="post" id="heavy_shipments" style={{ padding: 0 }}>
                                                <>
                                                    {[...Array(heavyCountShipment)].map((e, i) =>
                                                        <div className="quick-holder">
                                                            <div className="col-md-5 col-sm-5">
                                                                <h3 className="section-head">Where are you sending your parcels from/to?</h3>
                                                                <div className="tab-in-export-import" style={{ display: "flex", alignItems: "center" }}>
                                                                    <div style={{ width: "50%" }}>
                                                                        <div>
                                                                            <label>Shipment Direction:</label>
                                                                        </div>
                                                                        <a onClick={() => showheavydivlist('exportdiv', i)} style={{ cursor: 'pointer' }} className={`export-link in-send-package ${exportHeavyListClass[i]}`} id="export-link-ip">Export</a>
                                                                        <a onClick={() => showheavydivlist('importdiv', i)} style={{ cursor: 'pointer' }} className={`import-link in-send-package  ${importHeavyListClass[i]}`} id="import-link-ip">Import</a>
                                                                    </div>
                                                                    <div style={{ width: "50%" }}>
                                                                        <div>
                                                                            <label>Type of Shipment:</label>
                                                                        </div>
                                                                        <div>
                                                                            <a onClick={() => showheavytypedivlist('pallet', i)} style={{ cursor: 'pointer' }} className={`export-link in-send-package ${packHeavyListClass[i]}`} id="package-link">Pallet</a>
                                                                            <a onClick={() => showheavytypedivlist('carton', i)} style={{ cursor: 'pointer' }} className={`import-link in-send-package ${docHeavyListClass[i]}`} id="document-link">Carton</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* International Export Package */}
                                                                {getQuoteHeavydatalist[i].shipmenttype && getQuoteHeavydatalist[i].shipmenttype == 'exportdiv' ? (
                                                                    <div className="tab-in-export-package">
                                                                        <ul className="in-export-package from-to">
                                                                            <li>
                                                                                <label>From</label>
                                                                                <select
                                                                                    className="form-select select-export-package"
                                                                                    name="delivery_from"
                                                                                    onChange={(e) => {
                                                                                        const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
                                                                                        updatedData.map((item, index) => {
                                                                                            if (index == i) {
                                                                                                item.origin = e.target.value;
                                                                                                return item;
                                                                                            } else {
                                                                                                return item;
                                                                                            }
                                                                                        });
                                                                                        setgetQuoteHeavydatalist(updatedData); // Update the state with the new array
                                                                                    }}
                                                                                >
                                                                                    <option value="AE">Abu Dhabi</option>
                                                                                    <option value="AE">Ajman</option>
                                                                                    <option value="AE">Al Ain</option>
                                                                                    <option value="AE" selected >Dubai</option>
                                                                                    <option value="AE">Fujairah</option>
                                                                                    <option value="AE">Ras Al Khaimah</option>
                                                                                    <option value="AE">Sharjah</option>
                                                                                    <option value="AE">Umm Al Quwain</option>
                                                                                </select>
                                                                            </li>
                                                                            <li>
                                                                                <label>To</label>
                                                                                <select
                                                                                    className="form-select select-export-package"
                                                                                    name="delivery_to"
                                                                                    onChange={(e) => {
                                                                                        const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
                                                                                        updatedData[i] = { ...updatedData[i], destination: e.target.value }; // Update the specific object's origin
                                                                                        setgetQuoteHeavydatalist(updatedData); // Update the state with the new array
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        Object.entries(countries).map(([k, v]) => (
                                                                                            <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                ) : null
                                                                }
                                                                {/* End International Export Package */}
                                                                {/* International Import Package */}
                                                                {getQuoteHeavydatalist[i].shipmenttype && getQuoteHeavydatalist[i].shipmenttype == 'importdiv' ? (
                                                                    <div className="tab-in-import-package" >
                                                                        <ul className="in-import-package from-to">
                                                                            <li>
                                                                                <label>From</label>
                                                                                <select
                                                                                    className="form-select select-export-package"
                                                                                    name="delivery_to"
                                                                                    onChange={(e) => {
                                                                                        const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
                                                                                        updatedData.map((item, index) => {
                                                                                            if (index == i) {
                                                                                                item.origin = e.target.value;
                                                                                                return item;
                                                                                            } else return item;
                                                                                        });
                                                                                        setgetQuoteHeavydatalist(updatedData); // Update the state with the new array
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        Object.entries(countries).map(([k, v]) => (
                                                                                            <option key={k} value={k} selected={k === 'GB'}>{v}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                            </li>
                                                                            <li>
                                                                                <label>To</label>
                                                                                <select
                                                                                    className="form-select select-export-package"
                                                                                    name="delivery_from"
                                                                                    onChange={(e) => {
                                                                                        const updatedData = [...getQuoteHeavydatalist]; // Create a shallow copy of the array
                                                                                        updatedData[i] = { ...updatedData[i], destination: e.target.value }; // Update the specific object's origin
                                                                                        setgetQuoteHeavydatalist(updatedData); // Update the state with the new array
                                                                                    }}
                                                                                >
                                                                                    <option value="AE">Abu Dhabi</option>
                                                                                    <option value="AE">Ajman</option>
                                                                                    <option value="AE">Al Ain</option>
                                                                                    <option value="AE" selected >Dubai</option>
                                                                                    <option value="AE">Fujairah</option>
                                                                                    <option value="AE">Ras Al Khaimah</option>
                                                                                    <option value="AE">Sharjah</option>
                                                                                    <option value="AE">Umm Al Quwain</option>
                                                                                </select>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                ) : null
                                                                }
                                                                {/* End International Import Package */}
                                                            </div>
                                                            <div className="col-md-7 col-sm-7">
                                                                <div id="add_more_weight_package_in" className="add_more_weight">
                                                                    <div key={i}>
                                                                        <h3 className="section-head">Enter the weight and dimensions of your shipments {i > 0 ? (
                                                                            <button type="button" className="removebtn" onClick={() => removemore(i, 'heavy_shipment')}>x</button>
                                                                        ) : null} </h3>
                                                                        <div className="weight-section">
                                                                            <ul className="in-export-package from-to">

                                                                                <li>
                                                                                    <label>Weight* (kg)</label>
                                                                                    <select className="form-select" name="weight[]" onChange={(e) => updateHeavyWeight(e.target.value, i)}>
                                                                                        {i > 0 ? (
                                                                                            <option value="">select weight</option>
                                                                                        ) : null
                                                                                        }

                                                                                        {Array.from({ length: 1000 - 71 + 1 }, (v, k) => k + 71).map((k) => (
                                                                                            <option value={k} selected={getQuoteHeavydatalist[i].dimensions.weight[0] == k} key={k}>{k}</option>
                                                                                        ))}
                                                                                    </select>
                                                                                </li>
                                                                                <li>
                                                                                    <label>Length (cm)</label>
                                                                                    <input className="form-control" name="length[]" value={getQuoteHeavydatalist[i].dimensions.length[0]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updateHeavyLength(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                                <li>
                                                                                    <label>Width ({dimensionUnit})</label>
                                                                                    <input className="form-control" name="width[]" value={getQuoteHeavydatalist[i].dimensions.width[0]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updateHeavyWidth(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                                <li>
                                                                                    <label>Height ({dimensionUnit})</label>
                                                                                    <input className="form-control" name="height[]" value={getQuoteHeavydatalist[i].dimensions.height[0]} type="number" min={0} style={{ padding: "0.625rem" }} onChange={(e) => updateHeavyHeight(e.target.value, i)}
                                                                                        onKeyPress={(e) => {
                                                                                            const charCode = e.which ? e.which : e.keyCode;
                                                                                            // Allow only numbers (0-9) and control keys (like backspace)
                                                                                            if ((charCode < 48 || charCode > 57)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </li>
                                                                            </ul>
                                                                            {
                                                                                weightmsg && weightmsg == 1 ? (
                                                                                    <>
                                                                                        <p style={{ fontSize: '16px', fontWeight: 'bold', lineHeight: '8px' }}>Please contact us for rates</p>
                                                                                        <p style={{ fontSize: '16px', fontWeight: 'bold', paddingBottom: '5%' }}>Email: <span style={{ color: '#3c50e0' }}><a style={{ color: '#3c50e0' }} href="mailto:info@timexpress.ae?subject=Shypv Enquiry">sales@timexpress.ae</a></span>&nbsp;&nbsp; Phone: <span style={{ color: '#3c50e0' }}><a href="tel:600503327" style={{ textDecoration: 'none', color: '#3c50e0' }}>600503327</a></span></p>
                                                                                    </>
                                                                                ) : null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    countShipment == (i + 1) ? (
                                                                        <button onClick={() => increment('heavy_shipment')} className="btn btn-primary btn-parcels add-btn add_more_sizes" id="in_package" type="button" >Add another shipment </button>
                                                                    ) : null
                                                                }
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                                <hr className="hr_border" />
                                                <div className="container date_ship">
                                                    <div className="row">
                                                        <div className="col-md-8 col-sm-8">
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6">
                                                                    <h3 className="section-head"><mark>When are you shipping?</mark></h3>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6">
                                                                    <DatePicker className="form-control shipping_date" filterDate={isWeekday} name="shipping_date" dateFormat='dd/MM/yyyy' minDate={startDate2} selected={startDate} onChange={(date) => setscheduledate(date)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-sm-4">
                                                            <div className="wrape_promo" style={{ textAlign: 'center' }}>
                                                                <span className="get_center_bnts">
                                                                    {weightmsg && weightmsg == 1 ? (
                                                                        <button className="btn btn-primary" type="button" name="get_quotes" id="get_quote" flag="package" disabled onClick={() => getQuote("heavy")}>Get Quote</button>
                                                                    ) : (
                                                                        <button className="btn btn-primary" type="button" name="get_quotes" id="get_quote" flag="package" onClick={() => getQuote("heavy")}>Get Quote</button>
                                                                    )}

                                                                    <input type="hidden" name="get_quote" defaultValue="Get Quote" />
                                                                    <input type="hidden" name="parcel_type" id="in_parcel_type" defaultValue="export" />
                                                                    <input type="hidden" name="pac_type" id="pac-pac-link" defaultValue="package" />
                                                                    <input type="hidden" name="promo_discount" defaultValue id="promo_discount" />
                                                                </span>
                                                                {/* <div class="yodeldirect-hedding"><h3>Temporary Out of Service</h3></div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <Parcels_delivered /> */}

                {/* Admin Login Section */}
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    zIndex: 1000
                }}>
                    <Link 
                        to="/admin/login"
                        style={{
                            display: 'inline-block',
                            padding: '10px 20px',
                            backgroundColor: '#495057',
                            color: '#ffffff',
                            textDecoration: 'none',
                            borderRadius: '6px',
                            fontSize: '13px',
                            fontWeight: '500',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#343a40';
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#495057';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
                        }}
                    >
                        Admin Login
                    </Link>
                </div>

            </div>
        </div>
    )
}